import Styles from './styles.module.scss';

import type { TaskStatus } from '../../model/types/task.dto';
import type { DateTimeOffset } from '@/app/types/MessageContainer';

interface Props {
	time: DateTimeOffset;
	status: TaskStatus;
	formatDateTime: (value: DateTimeOffset, status: TaskStatus) => string;
}

export const Time = ({ time, status, formatDateTime }: Props) => {
	const date = formatDateTime(time, status);
	return <span className={Styles.time}>{date}</span>;
};
